import React from 'react';
import Select from 'react-select';
import { injectIntl } from 'react-intl';

class SelectTypeField extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // selectedValue: props.input.value,
      action: null, // what updated the checkbox
    };
  }

  // componentDidUpdate(prevProps) {
  //   const { action } = this.state;
  //   const { input, selectedValue } = this.props;

  //   // redux-form field value got updated.
  //   if (input.value !== prevProps.input.value && action === null) {
  //     this.onFieldUpdate(input.value, input);
  //   } else if (selectedValue !== prevProps.selectedValue) {
  //     this.onFieldUpdate(selectedValue);
  //   }
  // }

  // onFieldUpdate(selectedValue) {
  //   this.setState({
  //     selectedValue,
  //   });
  // }

  defaultSelectedOption = value => {
    const { meta, options } = this.props;
    if (meta.form === 'workListPatientSearchForm') {
      return options.filter(o => o.id == value);
    }
    if (meta.form === 'kardiaRxPatientSearchForm') {
      return options.filter(o => o.id == value);
    }
    if (meta.form === 'KardiaRxPatientCCTSearchForm') {
      return options.filter(o => o.id == value);
    }
    return options.filter(o => o.value === value);
  };

  renderOptionLabel = d => {
    const { intl, meta } = this.props;
    if (meta.form === 'workListPatientSearchForm') {
      return d.label;
    }
    if (meta.form === 'kardiaRxPatientSearchForm') {
      return d.label;
    }
    if (meta.form === 'KardiaRxPatientCCTSearchForm') {
      return d.label;
    }
    return intl.formatMessage({ id: d.label });
  };

  renderOptionValue = d => {
    const { meta } = this.props;
    if (meta.form === 'workListPatientSearchForm') {
      return d.id;
    }
    if (meta.form === 'kardiaRxPatientSearchForm') {
      return d.id;
    }
    if (meta.form === 'KardiaRxPatientCCTSearchForm') {
      return d.id;
    }
    return d.value;
  };

  render() {
    const {
      input,
      className = 'react-select-filter-selector',
      classNamePrefix = 'react-select-filter-selector',
      options,
      placeholder,
      getOptionLabel = this.renderOptionLabel,
      getOptionValue = this.renderOptionValue,
      getSelectedOption = this.defaultSelectedOption,
      onSelect,
      onClear,
      ...rest
    } = this.props;

    const { selectedValue } = this.props;
    return (
      <Select
        className={className}
        classNamePrefix={classNamePrefix}
        value={getSelectedOption(selectedValue)}
        options={options}
        getOptionLabel={getOptionLabel}
        onChange={(option, { action }) => {
          this.setState({
            action,
          });

          if (action === 'clear') {
            input.onChange(null);
            if (onClear) {
              onClear({ name: input.name });
            }
            return;
          }

          if (option) {
            if (typeof getOptionValue === 'function') {
              input.onChange(getOptionValue(option), input, option);
            } else {
              input.onChange(option);
            }
          }
          if (onSelect) onSelect(getOptionValue(option), input, option);
        }}
        placeholder={placeholder}
        {...rest}
      />
    );
  }
}

export default injectIntl(SelectTypeField);



// WEBPACK FOOTER //
// ./src/views/components/SelectTypeField/SelectTypeField.jsx